<template>
  <div class="el-autocomplete" v-clickoutside="handleClickoutside">
    <el-input
      ref="input"
      :value="model[labelField]"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      :name="name"
      :size="size"
      @compositionstart.native="handleComposition"
      @compositionupdate.native="handleComposition"
      @compositionend.native="handleComposition"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
      @keydown.up.native.prevent="highlight(highlightedIndex - 1)"
      @keydown.down.native.prevent="highlight(highlightedIndex + 1)"
      @keydown.enter.stop.native="handleKeyEnter"
      @click.native="handleIconClick"
    >
      <i slot="icon" class="el-input__icon icon" :class="ishover && model[labelField] ? 'el-icon-close' : 'hrfont hr-reference'" @click.stop="refClick(model[labelField], labelField, field, resdata)" @mouseenter="ishover = true" @mouseleave="ishover = false"> </i>
    </el-input>
    <reference-suggestions :class="[popperClass ? popperClass : '']" ref="suggestions" :suggestions="suggestions"> </reference-suggestions>
  </div>
</template>
<script>
import refs from '@/data/ref-reg'
import { getPage } from '@/pages'
import { getJson } from '@/utils/rest'
import Elm from '@/mixins/elm'
import Emitter from 'element-ui/lib/mixins/emitter'
//  import Clickoutside from './clickoutside.js'
import Clickoutside from './clickoutside-es6.js'
import ReferenceSuggestions from './reference-suggestions.vue'
import Vue from 'vue'

Vue.prototype.$closeReference = function(obj) {
  this.$dialogs.getCurrent().$reference.closeReference(obj)
}
export default {
  name: 'Reference',
  componentName: 'Reference',
  components: {
    ReferenceSuggestions
  },
  directives: { Clickoutside },
  mixins: [Elm, Emitter],
  props: {
    model: {
      type: Object,
      default: _ => ({})
    },
    resdata: Object,
    field: String,
    labelField: {
      type: String,
      default: function() {
        return this.field + '__label'
      }
    },
    popperClass: String,
    placeholder: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    readonly: {
      type: Boolean,
      default: true // 目前的参照不支持，实时搜索，默认设置为readonly
    },
    name: String,
    size: String,
    value: String,
    customSuggest: String,
    triggerOnFocus: {
      type: Boolean,
      default: true
    },
    suggest: [String, Array, Function],
    filter: {
      type: Function,
      default: function(filterString) {
        return function(item) {
          return item.label.indexOf(filterString.toLowerCase()) === 0
        }
      }
    },
    cached: {
      type: Boolean,
      default: true
    },
    refTo: [String, Object],
    refParam: Object,
    readFields: {
      type: [String, Array],
      default: _ => []
    },
    writeFields: {
      type: [String, Array],
      default: _ => []
    }
  },
  data: function() {
    return {
      isFocus: false,
      isOnComposition: false,
      suggestions: [],
      loading: false,
      highlightedIndex: -1,
      ishover: false
    }
  },
  computed: {
    suggestionVisible() {
      const suggestions = this.suggestions
      let isValidData = Array.isArray(suggestions) && suggestions.length > 0
      return (isValidData || this.loading) && this.isFocus
    }
  },
  watch: {
    suggestionVisible(val) {
      this.broadcast('ReferenceSuggestions', 'visible', [val, this.$refs.input.$refs.input.offsetWidth])
    }
  },
  methods: {
    refClick(content, label, field, resdata) {
      // console.log(content, label, field, resdata)
      if (!this.disabled) {
        if (this.ishover) {
          this.$emit('clear')
        }
        if (content) {
          this.model[label] = ''
          this.model[field] = ''
          this.model[resdata] = ''
        } else {
          if (this.disabled) return
          this.showReference()
          //          this.handleIconClick
        }
      }
    },
    getData(queryString) {
      this.loading = true
      this.fetchSuggestions(queryString, suggestions => {
        this.loading = false
        if (Array.isArray(suggestions)) {
          this.suggestions = suggestions
        } else {
        }
      })
    },
    handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false
        this.handleChange(event.data)
      } else {
        this.isOnComposition = true
      }
    },
    handleChange(value) {
      console.log(value)
      this.$emit('input', value)
      if (this.isOnComposition || (!this.triggerOnFocus && !value)) {
        this.suggestions = []
        return
      }
      if (this.readonly) return
      this.getData(value)
    },
    handleFocus() {
      this.isFocus = true
      this.$emit('focus')
    },
    handleBlur() {
      // 因为 blur 事件处理优先于 select 事件执行
      setTimeout(_ => {
        this.isFocus = false
      }, 100)
    },
    handleKeyEnter() {
      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
        this.select(this.suggestions[this.highlightedIndex])
      } else if (this.model[this.labelField] && this.suggestions.length === 1 && this.suggestions[0].label === this.model[this.labelField]) {
        this.select(this.suggestions[0])
      } else {
        this.select({})
      }
    },
    handleClickoutside() {
      if (!this.model[this.labelField]) {
        if (this.suggestions.length === 1 && this.suggestions[0].label === this.model[this.labelField]) {
          this.select(this.suggestions[0])
        } else {
          this.select({})
        }
      }
      this.isFocus = false
    },
    select(item) {
      this.model[this.field] = item['value']
      this.model[this.labelField] = item['label']
      this.model[this.resdata] = item['resdata']
      this.writeFields.forEach((f, i) => {
        if (i >= this.readFields.length) {
          this.model[f] = null
        } else {
          this.model[f] = item[f]
        }
      })
      this.$emit('input', item.value)
      this.$emit('select', item)
      if (this.disabled) {
        return
      }
      this.$nextTick(_ => {
        this.suggestions = []
      })
      this.highlight(-1)
    },
    highlight(index) {
      this.highlightedIndex = index
      if (!this.suggestionVisible || this.loading) {
        return
      }
      if (index < 0) index = 0
      if (index >= this.suggestions.length) {
        index = this.suggestions.length - 1
      }
      const suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap')
      const suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li')

      let highlightItem = suggestionList[index]
      let scrollTop = suggestion.scrollTop
      let offsetTop = highlightItem.offsetTop

      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
        suggestion.scrollTop += highlightItem.scrollHeight
      }
      if (offsetTop < scrollTop) {
        suggestion.scrollTop -= highlightItem.scrollHeight
      }
    },
    fetchSuggestions: function(inputString, cb) {
      if (!this.suggest) {
        return
      }
      if (!inputString) {
        cb([])
        return
      }
      let suggest = this.suggest
      if (typeof suggest === 'string') {
        getJson(suggest, { filter: inputString }).then(cb)
      } else if (typeof suggest === 'function') {
        suggest(inputString, cb)
      } else {
        cb(this.suggest.filter(this.filter(inputString)))
      }
    },
    handleIconClick() {
      if (this.disabled) return
      this.showReference()
    },
    setParams(params, isClear = true) {
      if (this.refParams === params) {
        return
      }
      this.refParams = params
      if (isClear) {
        this.model[this.field] = null
        this.model[this.labelField] = null
      }
      this.refresh = true
    },
    getDialogOptions() {
      let o = this
      let options = {
        params: o.refParam,
        dep: '#' + o.getElmID(),
        refresh: o.refresh,
        '@open': () => {
          o.$dialogs.getCurrent().$reference = o
        }
      }
      return options
    },
    showReference() {
      let conf = {}
      let ref = this.refTo
      if (typeof ref === 'string') {
        conf = refs[ref] || { component: getPage(ref) }
      } else {
        conf['component'] = ref
      }
      Object.assign(conf, this.getDialogOptions())
      this.$dialogs.show(conf)
    },
    closeReference(item = {}) {
      this.select(item)
      this.$dialogs.closeCurrent()
      this.$emit('afterReference', item, this)
    }
  },
  created: function() {
    if (!this.readFields) {
      this.readFields = []
    } else if (typeof this.readFields === 'string') {
      this.readFields = this.readFields.split(',')
    }
    if (!this.writeFields) {
      this.writeFields = []
    } else if (typeof this.writeFields === 'string') {
      this.writeFields = this.writeFields.split(',')
    }
  },
  mounted() {
    this.$on('item-click', item => {
      this.select(item)
    })
  },
  beforeDestroy() {
    this.$refs.suggestions.$destroy()
  }
}
</script>
<style lang="less" scoped>
.el-autocomplete {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// reference.vue?63920844